"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayPlan = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jyEduStages_1 = require("../../model/jyEduStages");
var service_1 = require("../../../library/base/service");
var RepayPlan = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RepayPlan, _super);
    function RepayPlan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '还款计划查询接口';
        _this.code = '101103';
        _this.desc = '还款计划查询接口';
        _this.requestParams = new jyEduStages_1.RepayPlanRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RepayPlan;
}(service_1.BaseService));
exports.RepayPlan = RepayPlan;
//# sourceMappingURL=repayPlan.js.map